import { Component, Injector, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApAlertService} from 'webcommon/core-ui';
import {
  FcJobScheduleTimeBaseDto,
  FcJobScheduleItemDto,
  FcModifyJobScheduleItemDto,
  FcJobItemDto,
} from 'webcommon/shared';
import { FcGenericItemModalBaseComponent } from '../../generic/fc-generic-item-modal-base.component';
import { FcListValidationService } from '../../generic/fc-list-validation/fc-list-validation.service';
import { DatePipe} from '@angular/common';

@Component({
  providers: [ApAlertService, FcListValidationService, DatePipe],
  selector: 'fc-jobschedule-modal',
  templateUrl: 'fc-jobschedule-modal.component.html',
})
export class FcJobScheduleListModalComponent extends FcGenericItemModalBaseComponent implements OnInit {

  public override baseId = 'fc-jobschedule-modal';

  public selectedJobUid: string[] = [];
  public selectedJobScheduleTimeBaseUid: string[] = [];
  public showNotes = true;
  public showJobSuccessHistoryDepth = true;


  public listItem: FcJobScheduleItemDto =
  {
      Id: '',
      ExternalId: '',
      Name: '',
      Notes: '',
      JobUid: '',
      Inactive: false,
      JobSuccessHistoryDepth: '0',
      JobScheduleTimeBaseUid: this.systemGuid.JobScheduleTimeBaseRunOnceUid,
      JobRepeatFrom: '',
      JobRepeatInterval: '',
      MethodParams: '',
      RunImmediately: false,
  };
  // Form Controls
  public externalIdControl = new FormControl();
  public nameControl = new FormControl();
  public notesControl = new FormControl();
  public jobControl = new FormControl();
  public inactiveControl = new FormControl();
  public jobSuccessHistoryDepthControl = new FormControl();
  public jobScheduleTimeBaseControl = new FormControl();
  public jobRepeatFromControl = new FormControl();
  public startTimeControl = new FormControl();
  public jobRepeatIntervalControl = new FormControl();
  public methodParamsControl = new FormControl();
  public userDefinedControl = new FormControl();
  public timeBaseNthSecondControl = new FormControl();
  public timeBaseNthMinuteControl = new FormControl();
  public timeBaseHourControl = new FormControl();
  public timeBaseDailyTypeControl = new FormControl();
  public timeBaseDailyTimeControl = new FormControl();
  public timeBaseWeeklyTimeControl = new FormControl();
  public timeBaseWeeklySundayControl = new FormControl();
  public timeBaseWeeklyMondayControl = new FormControl();
  public timeBaseWeeklyTuesdayControl = new FormControl();
  public timeBaseWeeklyWednesdayControl = new FormControl();
  public timeBaseWeeklyThursdayControl = new FormControl();
  public timeBaseWeeklyFridayControl = new FormControl();
  public timeBaseWeeklySaturdayControl = new FormControl();
  public timeBaseMonthlyDayOfMonthControl = new FormControl();
  public timeBaseMonthlyTimeControl = new FormControl();
  public runImmediatelyControl = new FormControl();

  public form: FormGroup = new FormGroup({
    externalId: this.externalIdControl,
    name: this.nameControl,
    notes: this.notesControl,
    jobUid: this.jobControl,
    inactive: this.inactiveControl,
    jobSuccessHistoryDepth: this.jobSuccessHistoryDepthControl,
    jobScheduleTimeBaseUid: this.jobScheduleTimeBaseControl,
    jobRepeatFrom: this.jobRepeatFromControl,
    jobRepeatInterval: this.jobRepeatIntervalControl,
    methodParams: this.methodParamsControl,
    userDefined: this.userDefinedControl,
    startTime: this.startTimeControl,
    timeBaseNthSecond: this.timeBaseNthSecondControl,
    timeBaseNthMinute: this.timeBaseNthMinuteControl,
    timeBaseHour: this.timeBaseHourControl,
    timeBaseDailyType: this.timeBaseDailyTypeControl,
    timeBaseDailyTime: this.timeBaseDailyTimeControl,
    timeBaseWeeklyTime: this.timeBaseWeeklyTimeControl,
    timeBaseWeeklySunday: this.timeBaseWeeklySundayControl,
    timeBaseWeeklyMonday: this.timeBaseWeeklyMondayControl,
    timeBaseWeeklyTuesday: this.timeBaseWeeklyTuesdayControl,
    timeBaseWeeklyWednesday: this.timeBaseWeeklyWednesdayControl,
    timeBaseWeeklyThursday: this.timeBaseWeeklyThursdayControl,
    timeBaseWeeklyFriday: this.timeBaseWeeklyFridayControl,
    timeBaseWeeklySaturday: this.timeBaseWeeklySaturdayControl,
    timeBaseMonthlyDayOfMonth: this.timeBaseMonthlyDayOfMonthControl,
    timeBaseMonthlyTime: this.timeBaseMonthlyTimeControl,
    runImmediately: this.runImmediatelyControl,
  });

  constructor(injector: Injector, private datePipe: DatePipe)
  {
      super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();

    this.loadListItem({});
  }


  public setForm(): void {

    this.externalIdControl.setValue(this.listItem.ExternalID);
    this.nameControl.setValue(this.listItem.Name);
    this.notesControl.setValue(this.listItem.Notes);
    this.inactiveControl.setValue(this.listItem.Inactive);
    this.jobSuccessHistoryDepthControl.setValue(this.listItem.JobSuccessHistoryDepth);


    this.jobRepeatFromControl.setValue(this.getDate(this.listItem.JobRepeatFrom || ''));
    this.jobRepeatIntervalControl.setValue(this.listItem.JobRepeatInterval);
    this.startTimeControl.setValue(this.getTime(this.listItem.JobRepeatFrom || ''));
    this.methodParamsControl.setValue(this.listItem.MethodParams);
    this.userDefinedControl.disable();
    this.userDefinedControl.setValue(this.listItem.UserDefined);
    this.selectedJobUid.push(this.listItem.JobUid);
    this.selectedJobScheduleTimeBaseUid.push(this.listItem.JobScheduleTimeBaseUid);

    this.timeBaseNthSecondControl.setValue(this.listItem.TimeBaseNthSecond);
    this.timeBaseNthMinuteControl.setValue(this.listItem.TimeBaseNthMinute);
    this.timeBaseHourControl.setValue(this.listItem.TimeBaseHour);
    this.timeBaseDailyTimeControl.setValue(this.getTime(this.listItem.TimeBaseDailyTime || ''));
    this.timeBaseDailyTypeControl.setValue(this.listItem.TimeBaseDailyType?.toString());
    this.timeBaseWeeklyTimeControl.setValue(this.getTime(this.listItem.TimeBaseWeeklyTime || ''));
    this.timeBaseWeeklySundayControl.setValue(this.listItem.TimeBaseWeeklySunday);
    this.timeBaseWeeklyMondayControl.setValue(this.listItem.TimeBaseWeeklyMonday);
    this.timeBaseWeeklyTuesdayControl.setValue(this.listItem.TimeBaseWeeklyTuesday);
    this.timeBaseWeeklyWednesdayControl.setValue(this.listItem.TimeBaseWeeklyWednesday);
    this.timeBaseWeeklyThursdayControl.setValue(this.listItem.TimeBaseWeeklyThursday);
    this.timeBaseWeeklyFridayControl.setValue(this.listItem.TimeBaseWeeklyFriday);
    this.timeBaseWeeklySaturdayControl.setValue(this.listItem.TimeBaseWeeklySaturday);
    this.timeBaseMonthlyTimeControl.setValue(this.getTime(this.listItem.TimeBaseMonthlyTime || ''));
    this.timeBaseMonthlyDayOfMonthControl.setValue(this.listItem.TimeBaseMonthlyDayOfMonth);

    this.runImmediatelyControl.setValue(this.listItem.RunImmediately);

    this.methodParamsControl.setValue(this.listItem.MethodParams);

    this.validateForm();

  }

  public override save(): void {
    const values = this.form.getRawValue();
    const methodParams: string = values.methodParams;

    const modifyItemDto: FcModifyJobScheduleItemDto = {
      ExternalID: values.externalId,
      Name: values.name,
      Notes: values.notes,
      JobUid: values.jobUid,
      Inactive: values.inactive,
      JobSuccessHistoryDepth: values.jobSuccessHistoryDepth,
      JobRepeatFrom: this.setDateTime(values.jobRepeatFrom, values.startTime),
      JobRepeatInterval: values.jobRepeatInterval,
      JobScheduleTimeBaseUid: values.jobScheduleTimeBaseUid,
      TimeBaseNthSecond: values.timeBaseNthSecond,
      TimeBaseNthMinute: values.timeBaseNthMinute,
      TimeBaseHour: values.timeBaseHour,
      TimeBaseDailyTime: values.timeBaseDailyTime,
      TimeBaseDailyType: values.timeBaseDailyType,
      TimeBaseWeeklyTime: values.timeBaseWeeklyTime,
      TimeBaseWeeklySunday: values.timeBaseWeeklySunday,
      TimeBaseWeeklyMonday: values.timeBaseWeeklyMonday,
      TimeBaseWeeklyTuesday: values.timeBaseWeeklyTuesday,
      TimeBaseWeeklyWednesday: values.timeBaseWeeklyWednesday,
      TimeBaseWeeklyThursday: values.timeBaseWeeklyThursday,
      TimeBaseWeeklyFriday: values.timeBaseWeeklyFriday,
      TimeBaseWeeklySaturday: values.timeBaseWeeklySaturday,
      TimeBaseMonthlyTime: values.timeBaseMonthlyTime,
      TimeBaseMonthlyDayOfMonth: values.timeBaseMonthlyDayOfMonth,
      MethodParams: methodParams,
      UserDefined: values.userDefined,
      RunImmediately: values.runImmediately
    };

    super.save<FcModifyJobScheduleItemDto>(modifyItemDto);
  }

  public onJobScheduleTimeBasePopulate(JobScheduleTimeBaseArray: FcJobScheduleTimeBaseDto[]): void {
    const JobScheduleTimeBaseData: FcJobScheduleTimeBaseDto = { ...JobScheduleTimeBaseArray[0] };
    if (JobScheduleTimeBaseData?.JobScheduleTimeBaseUid != null)
    {
      if (this.jobScheduleTimeBaseControl.value)
      {
        this.resetRepeatIntervalControls();
      }
      this.jobScheduleTimeBaseControl.setValue(JobScheduleTimeBaseData?.JobScheduleTimeBaseUid);
    }
    else
    {
      this.resetRepeatIntervalControls();
      this.jobScheduleTimeBaseControl.setValue(this.systemGuid.JobScheduleTimeBaseRunOnceUid);
    }

  }

  public onJobPopulate(jobArray: FcJobItemDto[]): void {
    const jobData: FcJobItemDto = { ...jobArray[0] };
    if (jobData?.JobUid != null)
    {
      this.jobControl.setValue(jobData?.JobUid);
    }
    else
    {
      this.jobControl.setValue(null);
    }
  }

  private getDate(rawDateTime: string): string
  {
    return this.datePipe.transform(rawDateTime, 'M/d/yyyy') || '';
  }

  private getTime(rawDateTime: string): string
  {
    return this.datePipe.transform(rawDateTime, 'HH:mm') || '';
  }

  private setDateTime(rawDate: Date, rawTime: string): string
  {
    let rawDateTime;
    if (rawDate instanceof Date)
    {
      rawDateTime = new Date(rawDate.toDateString() + ' ' + rawTime);
      return this.datePipe.transform(rawDateTime, 'M/d/yyyy HH:mm') || '';
    }
    if (rawDate === '')
    {
      return '';
    }
    else
    {
      rawDateTime = new Date(rawDate + ' ' + rawTime);
      return this.datePipe.transform(rawDateTime, 'M/d/yyyy HH:mm') || '';
    }
  }

  private resetRepeatIntervalControls()
  {
    this.timeBaseNthSecondControl.setValue('');
    this.timeBaseNthMinuteControl.setValue('');
    this.timeBaseHourControl.setValue('');
    this.timeBaseDailyTypeControl.setValue(1);
    this.timeBaseDailyTimeControl.setValue('');
    this.timeBaseWeeklyTimeControl.setValue('');
    this.timeBaseWeeklySundayControl.setValue(false);
    this.timeBaseWeeklyMondayControl.setValue(false);
    this.timeBaseWeeklyTuesdayControl.setValue(false);
    this.timeBaseWeeklyWednesdayControl.setValue(false);
    this.timeBaseWeeklyThursdayControl.setValue(false);
    this.timeBaseWeeklyFridayControl.setValue(false);
    this.timeBaseWeeklySaturdayControl.setValue(false);
    this.timeBaseMonthlyDayOfMonthControl.setValue('');
    this.timeBaseMonthlyTimeControl.setValue('');
  }
}
